import { useList, useTranslate } from "@refinedev/core";
import { Flex } from "antd";
import { Carousel } from "components/Carousel";
import { FatButton } from "components/FatButton/FatButton/";
import { TONES } from "data/tones";
import { ToneResponse } from "pages/media/types";
import { ReactNode } from "react";

export function ProjectSettingsFormTone<T>(
  props: Readonly<{
    value: T | undefined;
    onChange: (value: T) => void;
  }>
) {
  const t = useTranslate();
  const { data } = useList<ToneResponse>({
    resource: `media/tones`,
  });

  props.value ?? props.onChange("Professional" as T);
  const items = data?.data as {
    id: string;
    description: string;
  }[];
  const knownTones = Object.keys(TONES);
  const sortedItems = items?.toSorted(function (a, b) {
    return knownTones.indexOf(a.id) - knownTones.indexOf(b.id);
  });

  return (
    <Carousel
      slidesToShow={5}
      slidesToScroll={5}
      style={{
        height: 400,
        marginBottom: 20,
      }}
      numberOfElements={sortedItems?.length}
      initialSlide={sortedItems?.findIndex((item) => item.id === props.value)}
    >
      {sortedItems?.map((item) => {
        const Icon = TONES[item.id]?.icon;
        const toneData = t(`src.data.tones.${item.id}`, {
          returnObjects: true,
          defaultValue: {},
        }) as unknown as { name: string; characteristics: string[] };
        return (
          <Flex key={item.id}>
            <Flex
              style={{
                margin: 10,
              }}
              align="center"
              justify="center"
            >
              <FatButton
                title={toneData ? toneData?.name : item.id}
                content={
                  (
                    <>
                      <br />
                      {toneData?.characteristics?.join(" • ") ?? ""}
                    </>
                  ) as ReactNode & string
                }
                icon={Icon ? <Icon size={28} weight="duotone" /> : null}
                onClick={() => props.onChange(item.id as T)}
                type={props.value === item.id ? "primary" : "default"}
                checked={item.id === (props.value ?? "Professional")}
                style={{ height: 350, width: 230 }}
                size="small"
                contentFontWeight={300}
              />
            </Flex>
          </Flex>
        );
      })}
    </Carousel>
  );
}
